// src/pages/Marketplace/shared/useMarkets.ts
import { useCallback, useEffect, useState } from 'react';
import type { Market } from './types';

export function useMarkets(apiUrl: string, accessToken: string | null) {
  const [data, setData] = useState<Market[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!apiUrl || !accessToken) return;
    setLoading(true); setError(null);
    try {
      const res = await fetch(`${apiUrl}/admin/markets`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!res.ok) throw new Error(`GET /admin/markets ${res.status}`);
      const body = (await res.json()) as { items: Market[] };
      setData(body.items);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, [apiUrl, accessToken]);

  useEffect(() => { refetch(); }, [refetch]);

  return { data, loading, error, refetch };
}
